// Module-level accessor so non-React code (e.g. an app's HTTP error middleware) can surface a global
// error toast. The provider registers the real handler via setAlertAccessor on mount and clears it on
// unmount; apps without such middleware simply never call showGlobalError.
type ShowErrorFn = (message: string, activityTraceId?: string) => void;

let showErrorFn: ShowErrorFn | null = null;

export function setAlertAccessor(show: ShowErrorFn | null): void {
  showErrorFn = show;
}

export function showGlobalError(message: string, activityTraceId?: string): void {
  if (showErrorFn) {
    showErrorFn(message, activityTraceId);
  } else {
    console.error(message);
  }
}
